//export const baseUrl = "http://52.172.167.105:2255/api/";
console.log(process.env!.NODE_ENV);
export const baseUrl =
	process.env!.NODE_ENV === "development"
		? "https://businessanalysisv2-dev.azurewebsites.net/api/"
		: window.location.origin + "/api/";
// export const baseUrl = window.location.origin + "/api/";
